var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataView.isLoaded
    ? _c("div", [
        _c("div", { staticClass: "pageheader" }, [
          _c("h1", [
            _vm._v(
              "\n            " +
                _vm._s(this.dataView.forecast.title) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(this.dataView.forecast.description))]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page gc" },
          [
            _c("SideMenu"),
            _vm._v(" "),
            _vm.dataView.forecast.typeName === "Study"
              ? [
                  this.$route.params.section == "demand"
                    ? [_c("Demand")]
                    : this.$route.params.section == "materials"
                    ? [_c("Materials")]
                    : this.$route.params.section == "distribution"
                    ? [_c("Distribution")]
                    : this.$route.params.section == "events"
                    ? [_c("Events")]
                    : _vm._e(),
                ]
              : _vm.dataView.forecast.typeName === "Aggregation"
              ? [
                  this.$route.params.section == "demand"
                    ? [_c("AggregationDemand")]
                    : this.$route.params.section == "materials"
                    ? [_c("AggregationMaterials")]
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            this.$route.params.section == "share" ? [_c("Share")] : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }